import captcha from '@eqxiu/eqx-max-tools/lib/captcha.js'
import { getPhoneIdentCode, relMobileCode } from 'api/account'
import {
    mapGetters
} from 'vuex'
export default {
    data() {
        const valiPhone = (rule, value, callback) => {
            if (!/^1[3456789][0-9]{9}$/.test(value)) {
                callback(new Error('请填写正确的手机号'))
            } else {
                callback()
            }
        }

        return {
            formData: {
                phone: '',
                code: ''
            },
            rules: {
                phone: [{
                    validator: valiPhone,
                    trigger: 'blur'
                }],
                code: [
                    { required: true, message: '验证码不能为空', trigger: 'blur' }
                ]
            },
            errors: {
                code: '',
                phone: ''
            },
            codeTip: '获取验证码',
            countdown: 60,
            timer: null
        }
    },
    computed: {
        ...mapGetters('base', ['userInfo'])
    },
    methods: {
        triggerCode() {
            if (this.countdown !== 60) {
                return false
            }
            this.errors.code = ''
            this.errors.phone = ''
            const self = this
            captcha.init(function functionName(res) {
                if (res.ret === 0) { // 人机验证成功
                    self.getCode(res)
                }
            })
        },
        getCode({ ticket, randstr }) {
            if (this.userInfo.checkPhone || this.bindPhoneCode) {
                const params = {
                    phone: this.bindPhoneCode ? this.formData.phone : this.userInfo.phone,
                    ticket: ticket,
                    randstr
                }
                getPhoneIdentCode(params).then(res => {
                    if (res.data.success) {
                        this.setTimer()
                    } else {
                        this.errors.code = res.data.msg
                    }
                })
                    .finally(function () {
                        captcha.destroy()
                    })
            } else {
                const params = {
                    phone: this.formData.phone,
                    ticket: ticket,
                    randstr
                }
                relMobileCode(params).then(res => {
                    if (res.data.success) {
                        this.setTimer()
                    } else {
                        this.errors.code = res.data.msg
                    }
                })
                    .finally(function () {
                        captcha.destroy()
                    })
            }
        },
        setTimer() {
            if (this.countdown === 0) {
                this.codeTip = '获取验证码'
                this.countdown = 60
            } else {
                this.timer = setInterval(() => {
                    this.countdown--
                    this.codeTip = '重新发送' + '(' + this.countdown + ')'
                    if (this.countdown === 0) {
                        clearInterval(this.timer)
                        this.setTimer()
                    }
                }, 1000)
            }
        }
    }

}
